import TrustLogo from './TrustLogo.js';

export default TrustLogo;